import React, { useState, useEffect } from 'react';

import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { NoDataComponent, TwoGridSkeleton } from 'screens/admin/Reviews/ReviewProcess/ReviewCycle/Verify/common';
import { FormContainer, Separator } from 'screens/admin/Reviews/ReviewProcess/ReviewCycle/Verify/styles';
import { StyledTypography } from 'styles/common';

import { getSelectedTemplate } from 'services/engagement';
import { showErrorSnackbar } from 'services/snackbar';

import { Typography4 } from 'uiToolkit/Typography';

const getDisplayData = (data) => ({
  Template: data.name,
});

const TemplateSummary = ({ formId }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const getData = () => {
    getSelectedTemplate({ surveyId: formId })
      .then((res) => setData(res))
      .catch((err) => {
        dispatch(showErrorSnackbar('Sorry, unable to fetch the reminders!'));
      })
      .finally(() => setLoading(false));
  };

  useEffect(getData, []);

  const displayData = data ? getDisplayData(data) : null;

  return (
    <FormContainer>
      <StyledTypography color="#333" weight={600}>
        Survey Template
      </StyledTypography>
      <Separator />
      {loading ? (
        <TwoGridSkeleton />
      ) : (
        <>
          {displayData ? (
            Object.keys(displayData).map((key, i) => (
              <>
                <Grid container>
                  <Grid xs={6}>
                    <StyledTypography color="#888">{key}</StyledTypography>
                  </Grid>
                  <Grid xs={6}>
                    <StyledTypography color="#333">{displayData[key]}</StyledTypography>
                  </Grid>
                </Grid>
                {i < Object.keys(displayData).length - 1 && <Separator />}
              </>
            ))
          ) : (
            <NoDataComponent />
          )}
          {data?.isSample && (
            <Typography4 topGutter={2}>
              The template you have chosen uses some drivers that are not present in your account and will be added when
              you publish this survey
            </Typography4>
          )}
        </>
      )}
    </FormContainer>
  );
};

export default TemplateSummary;
